import UserDAO from "./UserDAO";

export default class ColaboradorDAO {
  static _key = "colaborador";
  static _keyAll = "colaboradores";

  static get() {
    return UserDAO.getProperty(ColaboradorDAO._key);
  }

  static getAll() {
	const colaboradores = UserDAO.getProperty(ColaboradorDAO._keyAll);
    if (!colaboradores) {
		return [];
	}
	return colaboradores;
  }

  static set(colaborador) {
    UserDAO.setProperty(ColaboradorDAO._key, colaborador);
  }

  static remove() {
    UserDAO.removeProperty(ColaboradorDAO._key);
  }

}
